import React from "react";
import ImagePartitionLayout from "../../layout/imagepartitionlayout/imagepartitionlayout";

import AuthenticationContainer from "../../components/AuthenticationContainer/authenticationcontainer";

import ResetPasswordForm from "./components/resetpasswordform";
import {RESET_SUBTITLE, WEBSITE_TITLE} from "../../constants/appconstants";

class ResetPassword extends React.Component {
    render() {
        return (
            <ImagePartitionLayout ContentComponent={ <AuthenticationContainer  Component={<ResetPasswordForm/>} titleLabel={"Reset Password"}/>}
                                  title={WEBSITE_TITLE}
                                  subtitle={
                                      ""}
            />
        );
    }
}

export default ResetPassword;



